import React from "react";
import { Modal } from "antd";
import CreditSelection from "../creditSelection/CreditSelection";

interface CreditModalProps {
    isOpen: boolean;
    toggle: () => void;
    onClose: () => void;
}

const CreditModal = ({ isOpen, toggle, onClose }: CreditModalProps) => {
    return <div className="paymentModal">
        <Modal open={isOpen} className="add-credits-modal" onCancel={toggle} width="600px" footer={() => null}>
            <CreditSelection onSuccess={onClose} />
        </Modal>
    </div>
}

export default CreditModal;